module.exports = __webpack_public_path__ + "static/media/hashirshoaeb.32f6b574.png";